export default {
  language: {
    title: 'Selecciona tu idioma',
    spanish: 'Español',
    english: 'Inglés',
    change: 'Cambiar idioma',
  },
  common: {
    accept: 'Aceptar',
    cancel: 'Cancelar',
    continue: 'Continuar',
    finish: 'Finalizar',
    back: 'Regresar',
    skip: 'Omitir',
    close: 'Cerrar',
    retry: 'Reintentar',
    yes: 'Sí',
    no: 'No',
    home: 'Inicio',
    sorry: 'Lo sentimos',
    poweredBy: 'Desarrollado por:',
    configuration: 'Configuración',
  },
  flow: {
    phoneTitle:
      '¡Compártenos tu número celular para confirmar tu orden vía SMS!',
    phonePlaceholder: 'Ingresa tu número de celular a 10 dígitos',
    nameTitle: '¡Compártenos tu nombre para poder identificar tu pedido!',
    namePlaceholder: 'Ingresa el nombre para identificar tu orden',
    selectTypeTitle: '¿Dónde vas a comer?',
    dineIn: 'Para comer aquí',
    pickup: 'Para llevar',
    turnTitle: 'Selecciona tu número de turno',
    turnMessage: 'Selecciona un turno de la barra e ingrésalo aquí por favor.',
  },
  menu: {
    favorites: 'Tus Favoritos',
    soldOut: 'Agotado',
    unavailable: 'No disponible',
    optional: 'Opcional',
    required: 'obligatorio(s)',
    maximum: 'Máximo',
    subtotal: 'Subtotal',
    total: 'Total',
    comments: 'Comentarios adicionales',
    addToOrder: 'Agregar a la orden',
    verifyModifiers: 'Verifica tus modificadores',
    modifierConfigurationRequired:
      'Debes verificar la configuración de los modificadores obligatorios',
    categories: 'Categorías',
    banners: 'Banners',
    confirm: 'Confirmar',
    requiredSingular: 'obligatorio',
    requiredPlural: 'obligatorios',
    requiredCount: '{count} {required}',
    selectedRequired: '{selected} / {minimum} {required}',
    maximumCount: 'Máximo {count}',
    requiredMaximum: '{minimum} {required}, Máximo {maximum}',
  },
  session: {
    present: '¿Estás ahí?',
    expiration:
      'Tu sesión expirará pronto. Por favor selecciona una de las siguientes opciones',
    exit: 'Salir',
  },
  unlock: {
    adminAccess: 'Acceso de administrador',
    confirmation:
      'Estás a punto de desbloquear el acceso administrador de este kiosco. Deberás ingresar la contraseña para completar esta acción.\n¿Deseas continuar?',
    action: 'Desbloquear',
    passwordPlaceholder: 'Ingresa la contraseña',
    incorrectPasswordTitle: 'Contraseña incorrecta',
    incorrectPasswordMessage: 'La contraseña proporcionada es incorrecta',
  },
  errors: {
    connection: 'Tenemos problemas para conectar con el servidor',
    missingConfiguration: 'Falta realizar configuración',
    cartNotFound: 'Carrito no encontrado',
    internal: 'Error interno',
    pinpadConfiguration: 'Falta realizar configuración de pinpad',
  },
  checkout: {
    order: 'Tu pedido',
    edit: 'Editar',
    payCash: 'Pagar en caja',
    payCard: 'Pagar con tarjeta',
    tip: 'Propina',
    noTip: 'Sin propina',
    amount: 'Monto',
    operation: 'Operación',
    authorization: 'Autorización',
    card: 'Tarjeta',
    date: 'Fecha',
    successfulPayment: 'Pago exitoso',
    successfulRefund: 'Reembolso exitoso',
    tipQuestion: '¿Cuánto deseas dejar de propina?',
    total: 'Total',
    soldOut: 'Agotado',
    addFood: 'Añadir alimentos',
    emptyOrder: 'Aún no tienes alimentos en tu pedido',
    noPaymentMethod: 'No hay método de pago activo, revisa la configuración',
    branchUnavailable: 'La sucursal no se encuentra disponible en este momento',
    confirmOrder: '¿Es correcta tu orden?',
    productImage: 'Producto',
    paymentInstructions:
      'Sigue las instrucciones en la terminal ubicada abajo de esta pantalla para completar tu pago.',
    paymentPending:
      'Tu orden se empezará a preparar una vez que hayas completado el pago.',
    paymentFailed:
      'Ocurrió un error al realizar el cobro. No se realizó ningún cargo a su tarjeta',
    paymentRetry: 'Inténtalo de nuevo o bien pasa a caja a pagar tu orden.',
    retryPayment: 'Intentar de nuevo',
    cardDeclined:
      'No se realizó ningún cargo a su tarjeta. La operación fue rechazada por su banco emisor. Favor de intentar con otra tarjeta.',
    confirmContinue: '¿Estás seguro que deseas continuar?',
    refundOrderFailed: 'No pudimos ingresar tu orden.',
    refundInsertCard:
      'Para realizar el proceso de devolución debes ingresar tu tarjeta en la terminal.',
    refundInstructions:
      'Sigue las instrucciones en la terminal ubicada abajo de esta pantalla para completar el reembolso.',
    refundCompleted: 'El reembolso se ha realizado de forma exitosa.',
    refundFailed:
      'Ocurrió un error al realizar el reembolso. Pasa a caja para solicitar apoyo.',
    paymentProcessing:
      'Tu pedido está siendo procesado y pronto recibirás la confirmación',
    thanksTitle: '¡Gracias por venir a {name}!',
    thanksDefault:
      '¡Gracias por tu compra! Recibirás un mensaje SMS cuando tu pedido se encuentre listo.',
    scanTicket:
      'Escanea el siguiente código QR para tener el ticket en tu celular.',
    downloadApp: '¡Descarga nuestra app!',
    appStore: 'Descargar en App Store',
    googlePlay: 'Descargar en Google Play',
    messageSent: 'Mensaje enviado exitosamente',
    success: 'Éxito',
    unavailableTitle: '¡UPS!',
    unavailableMessage:
      'Parece que uno de los productos que pediste acaba de agotarse.',
    unavailableAction:
      'Inténtalo de nuevo reemplazando el producto o borrándolo de tu orden.',
    soldOutProduct: 'Producto agotado',
    soldOutCart: 'Tu carrito contiene artículos que se nos han agotado',
    soldOutResolution:
      'Borra o sustituye el artículo seleccionado para continuar tu orden.',
    viewCart: 'Ver carrito',
    returnToCart: 'Volver al carrito',
    cancelOrder: 'Cancelar orden',
    logo: 'Logotipo',
    adomicilioLogo: 'Logotipo de Adomicilio',
    removeProductMessage:
      '¿Estás seguro que deseas eliminar este producto?\n\n Esta acción no se puede deshacer.',
    cancelOrderMessage:
      '¿Estás seguro que deseas cancelar tu orden?\n\n Esta acción no se puede deshacer.',
    wait: '¡Espera!',
    confirmRemove: 'Sí, eliminar',
    confirmCancel: 'Sí, cancelar',
    stayInOrder: 'Permanecer en mi orden',
    pickupReference: 'El usuario recogerá en la sucursal {branch}',
  },
  test: {
    printer: 'Prueba de impresora',
  },
};
